import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/wage-ledger/_layout/rule-and-policy/')({});